import { z } from "zod";

export const companyProfileEditSchema = z.object({
  company_name: z.string().min(1),
  is_listed: z.coerce.boolean().optional(),
  funds: z.coerce.number().optional(),
  ceo_name: z.string().min(1),
  established_date: z.coerce.date().optional(),
  homepage_url: z.string().url().optional().or(z.literal("")),
  company_address: z.string().optional(),
  corporate_number: z.string().optional(),
  employee_count: z.coerce.number().optional(),
  phone_number: z.string().optional(),
  company_name_kana: z.string().min(1),
  ceo_name_kana: z.string().min(1),
  position: z.string().min(1),
  email: z.string().email(),

  //Company Detail
  market_name: z.string().min(1),
  foreign_employee_count: z.coerce.number().min(0),
  permanent_employee_count: z.coerce.number().min(0),
  contract_employee_count: z.coerce.number().min(0),
  temporary_employee_count: z.coerce.number().min(0),
  contractor_count: z.coerce.number().min(0),
  part_time_employee_count: z.coerce.number().min(0),
  intern_count: z.coerce.number().min(0),
  specialist_count: z.coerce.number().min(0),
  employee_countries: z.string().min(1),
});

export type CompanyProfileEdit = z.infer<typeof companyProfileEditSchema>;
